import { SxStyle } from '@aibees/shared/theme';

export const content: SxStyle = {
  '.MuiFormHelperText-root': {
    marginTop: 0,
    paddingX: 3,
    fontSize: (p) => p.typography.body5.fontSize,
    fontWeight: 400,
  },
};

export const checkbox: SxStyle = {
  margin: 'auto',
  '.MuiStack-root': {
    display: 'contents',
  },
  '.MuiFormControlLabel-label': {
    fontSize: (p) => p.typography.body4.fontSize,
    fontWeight: (p) => p.typography.fontWeightMedium,
    color: (p) => p.palette.grey[600],
  },
  '.MuiFormControlLabel-asterisk': {
    fontSize: (p) => p.typography.body4.fontSize,
    fontWeight: (p) => p.typography.fontWeightMedium,
    color: (p) => p.palette.error[500],
  },
};

export const checkboxSub: SxStyle = {
  marginLeft: 3,
};
